export default __webpack_public_path__ + "static/media/img_5.d1808615.JPG";